<template>
	<div class="page-new-customer">
		<div class="new-customer__breadcrumbs">
			<span class="section-title section-title--new-customer">{{ label }}</span>
			<div class="notification-wrap-side">
				<PartNotifications :data="notificationsData" v-if="notificationsData.msg" />
			</div>
		</div>
		<div class="new-customer-form">
			<ValidationObserver ref="customerForm">
				<form class="new-customer-form__wrap" @submit.prevent="updateCustomer">
				<div class="error-messages__list" v-if="errors.length">
					<span class="error-messages__title">
						<SvgIcon class="error-messages__icon error-messages__icon--exclamation" iconName="ico-exclamation-circle"/>
						Please fill in all required fields:
					</span>
					<ul>
						<li class="error-messages__item" v-for="error in errors" :key="error">{{ error }}</li>
					</ul>
				</div>
					<span class="new-customer-form__input-title">Personal Information</span>
					<div class="new-customer-form__input-box">
						<div class="new-customer-form__input">
							<PartInputBasic v-model="customer.first_name" @capitalLetter="capitalLetter" ref="first_name" :data="DataName"/>
						</div>
						<div class="new-customer-form__input">
							<ValidationProvider rules="required"  v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
								<PartInputBasic v-model="customer.last_name" @capitalLetter="capitalLetter" :class="classes" ref="last_name" :data="DateLastName"/>
								<span ref="errors" class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
							</ValidationProvider>
						</div>
					</div>
					<div class="new-customer-form__input-box new-customer-form__input-box--full-width">
						<div class="new-customer-form__input">
							<PartInputBasic v-model="customer.company_name" ref="company_name" :data="DataCompanyName"/>
						</div>
					</div>
					<div class="new-customer-form__input-box new-customer-form__input-box--full-width">
						<div class="new-customer-form__input">
							<PartInputBasic v-model="customer.lead_source" ref="lead_source" :data="DataSource"/>
						</div>
					</div>
					<div class="new-customer-form__input-box new-customer-form__input-box--full-width">
						<div class="new-customer-form__input">
							<PartSwitch v-model="customer.end_user" ref="end_user" :data="DataEndUser"/>
						</div>
					</div>
					<div class="new-customer-form__input-box">
						<div class="new-customer-form__input">
							<ValidationProvider :rules="`${havePrimMail ? 'email' : ''}`" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block" ref="inputEmailValidator">
								<PartInputBasic v-model="customer.primary_email" :class="classes" ref="primary_email" :data="DataEmailPrimary"/>
								<span class="error-message">{{ errors[0]}}</span>
							</ValidationProvider>
						</div>
						<div class="new-customer-form__input">
							<ValidationProvider :rules="`${haveSecMail ? 'email' : ''}`" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block" ref="inputEmailValidator">
								<PartInputBasic v-model="customer.secondary_email" :class="classes" ref="secondary_email" :data="DataEmailSecondary"/>
								<span class="error-message">{{ errors[0]}}</span>
							</ValidationProvider>
						</div>
					</div>
					<div class="new-customer-form__input-box">
						<div class="new-customer-form__input">
							<ValidationProvider rules="required|min:5" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
								<PartInputBasic v-model="customer.primary_phone" v-mask="'###-###-####'" :class="classes" ref="primary_phone" :data="DataNumberPrimary"/>
								<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
							</ValidationProvider>
						</div>
						<div class="new-customer-form__input">
							<ValidationProvider :rules="`${haveSecPhone ? 'min:5' : ''}`" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
								<PartInputBasic v-model="customer.secondary_phone" v-mask="'###-###-####'" :class="classes" ref="secondary_phone" :data="DataNumberSecondary"/>
								<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
							</ValidationProvider>
						</div>
					</div>
					<span class="input-label">Address</span>
					<div class="new-customer-form__input-box new-customer-form__input-box--full-width">
						<div class="new-customer-form__input input__wrapper">
							<gmap-autocomplete
								ref="autocomplete"
								:select-first-on-enter="true"
								placeholder= "Address"
								@place_changed="setPlace('autoComplete', $event)"
								country="us">
							</gmap-autocomplete>
						</div>
					</div>
					<div class="new-customer-form__input-box new-customer-form__input-box--full-width">
						<div class="new-customer-form__input new-customer-form__input--textarea">
							<PartInputTextarea v-model="customer.note" ref="note" :data="DataNote"/>
						</div>
					</div>
					<div class="new-customer-form__input-box new-customer-form__input-box--full-width" v-if="checkPermissions()">
						<div class="new-customer-form__input">
							<PartSwitch v-model="assignToMe" ref="assignToMe" :data="DataAssignToMe"/>
						</div>
					</div>
					<span class="assign-to-sa-error" v-if="assignedToSuperAdmin">Customer is assigned to another Super Admin: <span class="assign-to-sa-error-name">{{customer.agent.last_name}} {{customer.agent.first_name}}</span> </span>

					<div class="property-form__input property-form__input--new-agent" ref="Agent" v-if="checkPermissions()">
						<ValidationProvider :rules="`${!blockEnterAgent ? 'required' : ''}`" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
							<PartSelect v-model="customer.agent_id" :class="classes" ref="agent_id" :data="DataAgent"/>
							<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
						</ValidationProvider>
						<div class="property-form__input-btn-new-agent">
							<a class="btn btn--icon" :class="{'btn--disabled': blockEnterAgent}" id="new-agent-popup-link" @click="showPopup">
								<SvgIcon class="property-form-agents__icon" iconName="ico-plus"/>
								<span>Add New</span>
							</a>
						</div>
					</div>
					<span class="new-customer-form__input-title">Seeking</span>
					<div class="new-customer-form__input-box select-big-input">
						<div class="new-customer-form__input">
							<PartCheckboxDropdown v-model="customer.offering_type" ref="offering_type" :data="DataOfferingType"/>
						</div>
						<div class="new-customer-form__input new-customer-form__input--list">
							<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
								<PartCheckboxDropdown v-model="customer.property_type" :class="classes" ref="property_type" :data="DataPropertyType"/>
								<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
							</ValidationProvider>
						</div>
					</div>
					<div class="new-customer-form__input-box new-customer-form__input-box--full-width">
						<div class="new-customer-form__input new-customer-form__input--area">
							<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
								<PartCheckboxDropdown v-model="customer.area" :class="classes" ref="area" :data="DataArea"/>
								<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
							</ValidationProvider>
						</div>
					</div>
					<div class="new-customer-form__input-box row">
						<div class="new-customer-form__vertical-input col-lg-6 col-md-6 col-sm-6">
							<div class="new-customer-form__input">
								<PartInputRange
									:data="DataBuildingSize"
									@valueFromChild="valueFromChild"
									:obj="{min: customer.building_size_min, max: customer.building_size_max}"
								/>
								<span class="error-message range-error" v-if="parseFloat(customer.building_size_min) > parseFloat(customer.building_size_max) && parseFloat(customer.building_size_max)">Max must be higher than Min</span>
							</div>
						</div>
						<div class="new-customer-form__vertical-input col-lg-6 col-md-6 col-sm-6">
							<div class="new-customer-form__input">
								<PartInputRange
									:data="DataLotSize"
									@valueFromChild="valueFromChild"
									:obj="{min: customer.lot_size_min, max: customer.lot_size_max}"
								/>
								<span class="error-message range-error" v-if="parseFloat(customer.lot_size_min) > parseFloat(customer.lot_size_max) && parseFloat(customer.lot_size_max)">Max must be higher than Min</span>
							</div>
						</div>
					</div>
					<div class="new-customer-form__input-box row">
						<div class="new-customer-form__vertical-input col-lg-6 col-md-6 col-sm-6">
							<div class="new-customer-form__input">
								<PartInputRange
									:data="DataPrice"
									@valueFromChild="valueFromChild"
									:obj="{min: customer.price_min, max: customer.price_max}"
								/>
								<span class="error-message range-error" v-if="parseFloat(customer.price_min) > parseFloat(customer.price_max) && parseFloat(customer.price_max)">Max must be higher than Min</span>
							</div>
						</div>
						<div class="new-customer-form__vertical-input col-lg-6 col-md-6 col-sm-6" v-if="contains(customer.property_type, ['industrial', 'warehouse-distribution'])">
							<div class="new-customer-form__input">
								<PartInputRange
									:data="DataPricePer"
									@valueFromChild="valueFromChild"
									:obj="{min: customer.price_psf_min, max: customer.price_psf_max}"
								/>
								<span class="error-message range-error" v-if="parseFloat(customer.price_psf_min) > parseFloat(customer.price_psf_max) && parseFloat(customer.price_psf_max)">Max must be higher than Min</span>
							</div>
						</div>
					</div>
					<div class="new-customer-form__input-box row">
						<div class="new-customer-form__vertical-input col-lg-6 col-md-6 col-sm-6" v-if="checkOfferingType()">
							<div class="new-customer-form__input">
								<PartInputRange
									:data="DataLeasePrice"
									@valueFromChild="valueFromChild"
									:obj="{min: customer.lease_price_min, max: customer.lease_price_max}"
								/>
								<span class="error-message range-error" v-if="parseFloat(customer.lease_price_min) > parseFloat(customer.lease_price_max) && parseFloat(customer.lease_price_max)">Max must be higher than Min</span>
							</div>
						</div>
						<div class="new-customer-form__vertical-input col-lg-6 col-md-6 col-sm-6" v-if="contains(customer.property_type, ['land', 'commercial-development', 'residential-development'])">
							<div class="new-customer-form__input">
								<PartInputRange
									:data="DataPriceBuildableSquareFoot"
									@valueFromChild="valueFromChild"
									:obj="{min: customer.price_buildable_sf_min, max: customer.price_buildable_sf_max}"
								/>
								<span class="error-message range-error" v-if="parseFloat(customer.price_buildable_sf_min) > parseFloat(customer.price_buildable_sf_max) && parseFloat(customer.price_buildable_sf_max)">Max must be higher than Min</span>
							</div>
						</div>
					</div>
					<div class="new-customer-form__input-box row">
						<div class="new-customer-form__vertical-input col-lg-6 col-md-6 col-sm-6" v-if="checkOfferingType()">
							<div class="new-customer-form__input">
								<PartInputRange
									:data="DataPriceYearly"
									@valueFromChild="valueFromChild"
									:obj="{min: customer.yearly_price_min, max: customer.yearly_price_max}"
								/>
								<span class="error-message range-error" v-if="parseFloat(customer.yearly_price_min) > parseFloat(customer.yearly_price_max) && parseFloat(customer.yearly_price_max)">Max must be higher than Min</span>
							</div>
						</div>
					</div>
					<!--<div class="new-customer-form__input-box new-customer-form__input-box--full-width">
						<div class="new-customer-form__input">
							<PartInputTags v-model="customer.keywords" ref="keywords" :data="DataKeywords"/>
						</div>
					</div>-->
					<div class="new-customer-form__input-box new-customer-form__input-box--full-width">
						<div class="new-customer-form__input new-customer-form__input--textarea">
							<PartInputTextarea v-model="customer.critical_note" ref="critical_note" :data="DataCriticalNotes"/>
						</div>
					</div>
					<div class="new-customer-form__buttons">
						<a class="btn btn--new-customer" :class="{'btn--disabled': btnIsDisabled}" :disabled="btnIsDisabled" @click="updateCustomer()">
							<SvgIcon class="save-icon" iconName="ico-save"/>
							<span>Save</span>
						</a>
						<router-link class="btn btn--white btn--new-customer" :to="{ name: checkPermissions() ? 'CustomersAdmin' : 'CustomersAgent' }">
							<span>Cancel</span>
						</router-link>
					</div>
				</form>
			</ValidationObserver>
			<PartLoaderBig class="loader-dash" v-if="pageLoader"/>
		</div>
		<div class="popup__new-agent" v-if="showModal">
			<div class="popup__wrap" v-on-click-outside.static="closePopup">
				<BlockEditAgent
					:data="DataNewAgentPopup"
					@closePopup="closePopup"
					@setAgent="setAgent"
				/>
				<a class="popup__close" @click="closePopup">
					<SvgIcon class="save-icon" iconName="ico-close-sm"/>
				</a>
			</div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import { gmapApi } from 'vue2-google-maps';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartInputBasic from '@/components/parts/PartInputBasic';
import PartInputTextarea from '@/components/parts/PartInputTextarea';
import PartCheckboxDropdown from '@/components/parts/PartCheckboxDropdown';
import PartInputRange from '@/components/parts/PartInputRange';
// import PartInputTags from '@/components/parts/PartInputTags';
import { check } from '@/services/RouteGuards/SuperAdmin';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import PartSelect from '@/components/parts/PartSelect';
import BlockEditAgent from '@/components/blocks/Admin/Agents/BlockEditAgent';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, min } from 'vee-validate/dist/rules';
import PartNotifications from '@/components/parts/PartNotifications';
import PartSwitch from '@/components/parts/PartSwitch';
import PartLoaderBig from '@/components/parts/PartLoaderBig';

Vue.use(VueGoogleMaps, {
	load: {
		key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
		libraries: 'places'
	},
	installComponents: true
});

extend('required', {
	...required,
	message: 'This field is mandatory.'
});

extend('email', {
	...email,
	message: 'Email must be in correct format.'
});

extend('min', {
	...min,
	message: 'Minimum number of characters is 5.'
});

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		edit: Boolean
	},
	mixins: [onClickOutside],

	data() {
		return {
			errors: [],
			pageLoader: false,
			label: this.edit ? 'Edit Customer' : 'Add New',
			search_input: '',
			autocompleteSearch: {},
			google: gmapApi,
			customer: {
				id: this.edit ? this.$route.params.id : 0,
				first_name: '',
				last_name: '',
				end_user: false,
				company_name: '',
				lead_source: '',
				primary_email: '',
				secondary_email: '',
				primary_phone: '',
				secondary_phone: '',
				address: '',
				note: '',
				agent_id: '',
				offering_type: [],
				area: [],
				property_type: [],
				building_size_min: '',
				building_size_max: '',
				lot_size_min: '',
				lot_size_max: '',
				price_min: '',
				price_max: '',
				price_psf_min: '',
				price_psf_max: '',
				price_buildable_sf_max: '',
				price_buildable_sf_min: '',
				lease_price_max: '',
				lease_price_min: '',
				yearly_price_min: '',
				yearly_price_max: '',
				keywords: [],
				critical_note: ''
			},
			havePrimMail: false,
			haveSecMail: false,
			haveSecPhone: false,
			btnIsDisabled: false,
			notificationsData: {
				type: '',
				msg: ''
			},
			showModal: false,
			DataName: {
				label: 'First Name',
				type: 'text',
				inputId: 'first_name-input',
				labelId: 'first_name-label',
				placeholder: 'Enter First Name',
				mandatoryFiled: false
			},
			DateLastName: {
				lastname: '',
				label: 'Last Name',
				inputId: 'last_name-input',
				labelId: 'last_name-label',
				type: 'text',
				placeholder: 'Enter Last Name',
				mandatoryFiled: true
			},
			DataCompanyName: {
				label: 'Company Name',
				inputId: 'company_name_customer-input',
				labelId: 'company_name_customer-label',
				type: 'text',
				placeholder: 'Enter Company Name',
				mandatoryFiled: false
			},
			DataSource: {
				label: 'Lead Source',
				inputId: 'lead_source_customer-input',
				labelId: 'lead_source_customer-label',
				type: 'text',
				placeholder: 'Enter Source',
				mandatoryFiled: false
			},
			DataEndUser: {
				label: 'End User',
				inputId: 'end-user-input',
				labelId: 'end-user-label'
			},
			DataAssignToMe: {
				label: 'Assign to me',
				inputId: 'assign-to-me-input',
				labelId: 'assign-to-me-label'
			},
			DataEmailPrimary: {
				emailPrimary: '',
				inputId: 'primary_email-input',
				labelId: 'primary_email-label',
				label: 'Primary Email',
				type: 'email',
				placeholder: 'Enter Primary Email',
				mandatoryFiled: false
			},
			DataEmailSecondary: {
				inputId: 'secondary_email-input',
				labelId: 'secondary_email-label',
				label: 'Secondary Email',
				type: 'email',
				placeholder: 'Enter Secondary Email',
				mandatoryFiled: false
			},
			DataNumberPrimary: {
				inputId: 'primary_number-input',
				labelId: 'primary_number-label',
				label: 'Primary Phone',
				type: 'text',
				placeholder: 'Enter Primary Phone',
				numberPrimary: '',
				mandatoryFiled: true
			},
			DataNumberSecondary: {
				inputId: 'secondary_email-input',
				labelId: 'secondary_email-label',
				label: 'Secondary Phone',
				type: 'text',
				placeholder: 'Enter Secondary Phone',
				mandatoryFiled: false
			},
			DataAddressSecond: {
				inputId: 'secondary_address-input',
				labelId: 'secondary_address-label',
				label: 'Address',
				type: 'text',
				placeholder: 'Enter Address',
				mandatoryFiled: false
			},
			DataNote: {
				label: 'Other Notes',
				placeholder: 'Type in your note here',
				classTextarea: 'new-customer__textarea',
				mandatoryFiled: false
			},
			DataAgent: {
				label: 'Agent',
				placeholder: 'Enter Agent',
				inputId: 'agents-input',
				labelId: 'agents-label',
				searchable: true,
				mandatoryFiled: true,
				options: [],
				disabled: false
			},
			DataOfferingType: {
				label: 'Offering Type',
				labelId: 'offering-type-new-customer-label',
				inputId: 'offering-type-new-customer-input',
				placeholder: 'Add Type',
				mandatoryFiled: false,
				options: [],
				multiple: true
			},
			DataArea: {
				label: 'Area',
				placeholder: 'Add Area',
				labelId: 'area-new-customer-label',
				inputId: 'area-new-customer-input',
				mandatoryFiled: true,
				options: [],
				multiple: true
			},
			DataPropertyType: {
				required: true,
				label: 'Property Type',
				labelId: 'type-new-customer-label',
				inputId: 'type-new-customer-input',
				placeholder: 'Add Property Type',
				mandatoryFiled: true,
				options: [],
				multiple: true
			},
			DataBuildingSize: {
				label: 'Building Size',
				labelId: 'building-size-new-customer-label',
				inputIdMin: 'building-size-new-customer-input-min',
				inputIdMax: 'building-size-new-customer-input-max',
				iconName: 'ico-buildings',
				classIcon: 'input-icon-box input-icon-box--big',
				flag: 'building_size'
			},
			DataPriceBuildableSquareFoot: {
				label: 'Price per Buildable Square Foot',
				labelId: 'price_buildable_square_foot-new-customer-label',
				inputIdMin: 'price_buildable_square_foot-new-customer-input-min',
				inputIdMax: 'price_buildable_square_foot-new-customer-input-max',
				iconName: 'ico-dollar-sign',
				classIcon: 'input-icon-box input-icon-box--big',
				flag: 'price_buildable_sf',
				currency: true
			},
			DataLeasePrice: {
				label: 'Lease Price',
				labelId: 'lease_price-new-customer-label',
				inputIdMin: 'lease_price-new-customer-input-min',
				inputIdMax: 'lease_price-new-customer-input-max',
				iconName: 'ico-dollar-sign',
				classIcon: 'input-icon-box input-icon-box--big',
				flag: 'lease_price',
				currency: true
			},
			DataLotSize: {
				label: 'Lot Size',
				labelId: 'lot-size-new-customer-label',
				inputIdMin: 'lot-size-new-customer-input-min',
				inputIdMax: 'lot-size-new-customer-input-max',
				iconName: 'ico-buildings',
				classIcon: 'input-icon-box input-icon-box--big',
				flag: 'lot_size'
			},
			DataPrice: {
				label: 'Price',
				labelId: 'price-new-customer-label',
				inputIdMin: 'price-new-customer-input-min',
				inputIdMax: 'price-new-customer-input-max',
				iconName: 'ico-dollar-sign',
				classIcon: 'input-icon-box',
				flag: 'price',
				currency: true
			},
			DataPricePer: {
				labelId: 'price-per-new-customer-label',
				inputIdMin: 'price-per-new-customer-input-min',
				inputIdMax: 'price-per-new-customer-input-max',
				label: 'Price per Square Foot',
				iconName: 'ico-dollar-sign',
				classIcon: 'input-icon-box',
				flag: 'price_psf',
				currency: true
			},
			DataPriceYearly: {
				labelId: 'yearly-price-new-customer-label',
				inputIdMin: 'yearly-price-new-customer-input-min',
				inputIdMax: 'yearly-price-new-customer-input-max',
				label: 'Yearly Price per Square Foot',
				iconName: 'ico-dollar-sign',
				classIcon: 'input-icon-box',
				flag: 'yearly_price',
				currency: true
			},
			DataKeywords: {
				label: 'Keywords',
				placeholder: 'Add Keyword'
			},
			DataCriticalNotes: {
				label: 'Critical Notes',
				placeholder: 'Type in your note here',
				classTextarea: 'new-customer__textarea',
				mandatoryFiled: false
			},
			DataNewAgentPopup: {
				popupIcon: 'ico-close-sm',
				noAgentPage: true
			},
			classScroll: 'prevent-scroll',
			cloneCustomer: false,
			assignToMe: false,
			assignedToSuperAdmin: false,
			blockEnterAgent: false
		};
	},
	components: {
		SvgIcon,
		PartInputTextarea,
		PartInputBasic,
		PartCheckboxDropdown,
		PartSwitch,
		PartInputRange,
		// PartInputTags,
		PartSelect,
		BlockEditAgent,
		ValidationProvider,
		ValidationObserver,
		PartLoaderBig,
		PartNotifications
	},
	computed: {
		user() {
			return this.$store.getters.getUser;
		}
	},
	watch: {
		customer: {
			handler(val) {
				this.havePrimMail = !!val.primary_email;
				this.haveSecMail = !!val.secondary_email;
				this.haveSecPhone = !!val.secondary_phone;
			},
			deep: true
		},
		assignToMe: {
			handler(val) {
				if (val) {
					this.blockEnterAgent = true;
					this.DataAgent.disabled = true;
					this.DataAgent.mandatoryFiled = false;
					this.customer.agent_id = this.user.id;
					this.$refs.agent_id.setValue('');
					this.assignedToSuperAdmin = false;
				} else {
					this.blockEnterAgent = false;
					this.DataAgent.disabled = false;
					this.DataAgent.mandatoryFiled = true;
					this.customer.agent_id = '';
				}
			},
			deep: true
		}
	},
	created() {
		if (this.$route.fullPath.includes('clone')) {
			this.cloneCustomer = true;
		}
		const dropFields = ['offering_type_customer', 'areas', 'property_filter', 'agents'];
		this.$store.dispatch('fetchDropDownOptions', { values: dropFields }).then((res) => {
			const data = res.data;
			this.DataOfferingType.options = data.offering_type_customer;
			this.DataArea.options = data.areas;
			this.DataPropertyType.options = data.property_filter;

			if (this.checkPermissions()) {
				this.DataAgent.options = data.agents;
			}
		});
		if (this.edit) {
			this.$store.dispatch('fetchCustomer', this.customer.id).then(response => {
				this.customer = this.cleanObject(response.data.customer);
				return this.customer;
			}).then(response => {
				if (this.cloneCustomer) {
					this.resetValuesForClone();
				}

				for (const key in response) {
					if (this.$refs[key] && this.$refs[key].setValue) {
						this.$refs[key].setValue(this.customer[key]);
					}
				}
				if (this.customer.address) {
					this.$refs.autocomplete.$el.value = this.customer.address;
				} else {
					this.$refs.autocomplete.$el.value = '';
				}

				// If customer is assigned to you
				if (this.customer.assing_to_me) {
					this.$refs.assignToMe.setValue(true);
					this.assignToMe = true;
					this.blockEnterAgent = true;
					this.DataAgent.disabled = true;
					this.DataAgent.mandatoryFiled = false;
					this.$refs.agent_id.setValue('');
				}

				// If customer is assigned to another super admin
				if (this.customer.assing_to_super_admin) {
					this.assignedToSuperAdmin = true;
					this.blockEnterAgent = true;
					this.DataAgent.disabled = true;
					this.DataAgent.mandatoryFiled = false;
					this.$refs.agent_id.setValue('');
				}

				this.validateInit();
			});
		}
	},
	methods: {
		capitalLetter(event) {
			event.target.value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1);
		},
		updateCustomer() {
			const rangeError = document.querySelector('.range-error');
			this.pageLoader = true;
			if (!this.btnIsDisabled) {
				this.btnIsDisabled = true;
				this.$refs.customerForm.validate().then(success => {
					if (success && !rangeError) {
						this.checkPrices();

						if (this.cloneCustomer) {
							this.customer.id = 0;
						}

						if (this.assignToMe) {
							this.customer.agent_id = this.user.id;
						}

						if (this.customer.first_name && this.customer.first_name.length) {
							this.customer.first_name = this.capitalizeFirstLetter(this.customer.first_name);
						}

						if (this.customer.last_name && this.customer.last_name.length) {
							this.customer.last_name = this.capitalizeFirstLetter(this.customer.last_name);
						}

						this.$store.dispatch('updateCustomer', this.customer).then(() => {
							setTimeout(() => {
								this.btnIsDisabled = false;
								this.backOnListing();
								this.pageLoader = false;
							}, 1000);
						});
					} else {
						this.pageLoader = false;
						this.btnIsDisabled = false;
						const msg = success && rangeError ? 'Max must be higher than Min' : '';
						const status = 400;
						this.notification(msg, status);
						// error messages list
						this.createErrorList();
						window.scrollTo({
							top: 0,
							behavior: 'smooth'
						});
					}
				});
			}
		},
		capitalizeFirstLetter(string) {
			return string[0].toUpperCase() + string.slice(1);
		},
		createErrorList() {
			this.errors = [];
			const user = JSON.parse(localStorage.getItem('user'));
			if (this.customer.last_name && (this.customer.area.length > 0) && this.customer.primary_phone && (this.customer.secondary_phone && this.customer.secondary_phone.length >= 5) &&
			(this.customer.primary_email && this.validEmail(this.customer.primary_email)) &&
			(this.customer.secondary_email && this.validEmail(this.customer.secondary_email)) &&
			(this.customer.primary_phone.length >= 5) && this.customer.agent_id && this.customer.property_type) return true;
			if (!this.customer.last_name) this.errors.push('Last Name is required.');
			if (this.customer.primary_email && !this.validEmail(this.customer.primary_email)) this.errors.push('Email must contain valid information.');
			if (this.customer.secondary_email && !this.validEmail(this.customer.secondary_email)) this.errors.push('Email must contain valid information.');
			if (!this.customer.primary_phone) this.errors.push('Primary Phone is required.');
			if (this.customer.secondary_phone && this.customer.secondary_phone.length < 5) this.errors.push('Phone must contain valid information.');
			if (this.customer.primary_phone && this.customer.primary_phone.length < 5) this.errors.push('Phone must contain valid information.');
			if ((user.role === 'admin' || user.role === 'super_admin') && !this.blockEnterAgent) {
				if (this.customer.agent_id.length === 0) this.errors.push('Agent is required.');
			}
			if (this.customer.area.length === 0) this.errors.push('Area is required.');
			if (this.customer.property_type.length === 0) this.errors.push('Property Type is required.');
			return false;
		},
		validEmail: function (email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		setPlace(type, $event) {
			this.customer.address = $event.formatted_address;
		},
		notification(msg, status) {
			this.notificationsData.msg = msg;
			this.notificationsData.type = status === 200 ? 'success' : 'danger';

			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});

			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 2000);
		},
		validateInit() {
			this.btnIsDisabled = true;
			this.$refs.customerForm.validate().then(success => {
				if (success) {
					this.btnIsDisabled = false;
				} else {
					this.pageLoader = false;
					this.btnIsDisabled = false;
					const msg = 'You have not filled in all required fields.';
					const status = 400;
					this.notification(msg, status);
				}
			});
		},
		backOnListing() {
			if (this.$route.name !== ('CustomersAdmin' || 'CustomersAgent')) {
				this.$router.push({ name: this.checkPermissions() ? 'CustomersAdmin' : 'CustomersAgent' });
			}
		},
		checkPermissions() {
			return check();
		},
		closePopup() {
			this.showModal = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		setAgent(agentId) {
			this.$store.dispatch('fetchAgentsSimple').then((res) => {
				this.DataAgent.options = res.data.agents;
				this.$refs.agent_id.setValue(agentId);
			});
		},
		showPopup() {
			this.showModal = true;
			this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
		},
		valueFromChild(obj, flag) {
			for (const key in obj) {
				const prop = `${flag}_${key}`;
				this.customer[prop] = obj[key];
			}
		},
		//	Check if user select appropriate value in dropdown and show/hide new fields for prices
		contains(choosenValues, valueForCheck) {
			if (choosenValues.length && Array.isArray(choosenValues)) {
				let hit = false;
				choosenValues.forEach(choosenEl => {
					valueForCheck.forEach(checkEl => {
						if (choosenEl === checkEl) {
							hit = true;
						}
					});
				});
				return hit;
			}
		},
		// Check and reset new prices
		checkPrices() {
			if (this.customer.offering_type === undefined || !this.customer.offering_type.includes('lease')) {
				this.customer.lease_price_min = '';
				this.customer.lease_price_max = '';
				this.customer.yearly_price_min = '';
				this.customer.yearly_price_max = '';
			}

			if (!this.contains(this.customer.property_type, ['land', 'commercial-development', 'residential-development'])) {
				this.customer.price_buildable_sf_min = '';
				this.customer.price_buildable_sf_max = '';
			}

			if (!this.contains(this.customer.property_type, ['industrial', 'warehouse-distribution'])) {
				this.customer.price_psf_min = '';
				this.customer.price_psf_max = '';
			}
		},
		checkOfferingType() {
			if (this.customer.offering_type === undefined) {
				return false;
			} else {
				return this.customer.offering_type.includes('lease');
			}
		},
		resetValuesForClone() {
			this.customer.offering_type = [];
			this.customer.property_type = [];
			this.customer.area = [];
			this.customer.building_size_min = '';
			this.customer.building_size_max = '';
			this.customer.lot_size_min = '';
			this.customer.lot_size_max = '';
			this.customer.price_min = '';
			this.customer.price_max = '';
			this.customer.price_psf_min = '';
			this.customer.price_psf_max = '';
			this.customer.lease_price_min = '';
			this.customer.lease_price_max = '';
			this.customer.price_buildable_sf_min = '';
			this.customer.price_buildable_sf_max = '';
			this.customer.yearly_price_min = '';
			this.customer.yearly_price_max = '';
			this.customer.keywords = [];
			this.customer.critical_note = '';
		}
	}
};
</script>
<style lang="scss" scoped>

	input {
		display: block;
		box-shadow: none;
		border: 1px solid $grey-light;
		padding: 16px;
		max-width: 100%;
		line-height: 1.2;
		width: 100%;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;

		@include mq($sm) {
			font-size: 16px;
			padding: 13px;
		}

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}
	}

.hideError {
	.error-message {
		display: none !important;
	}
}

.page-new-customer {
	padding-bottom: 157px;

	.btn--new-customer {
		max-width: 147px;

		&:not(:first-of-type) {
			margin-left: 50px;
		}
	}
}

.save-icon {
	margin-right: 11px;
	svg {
		font-size: 20px;
		color: $white;
	}
}

.btn--disabled {
	opacity: .5;
	cursor: default !important;
	pointer-events: none;

	@include hover {
        background-color: $dodger-blue;
        color: $white;
    }
}

.new-customer-form {
	max-width: 644px;
    margin: 0 auto;
    padding: 0 15px;
}

.new-customer-form__input-title {
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: $white;
	background-color: $fiord;
	padding: 13px 12px;
    display: flex;
	margin-bottom: 18px;
}

.new-customer-form__input {
	position: relative;
	input {
		border-radius: 8px;
		background-color: $white-lilac;
	}
	&:first-of-type {
		margin-right: 20px;

		@include mq($sm) {
			margin-right: 0;
		}
	}

	&.select-input-form {
		margin-right: 21px;

		@include mq($sm) {
			margin-right: 0;
		}
	}
}

.new-customer-form__input--textarea {
	margin-bottom: 17px;
}

.new-customer-form__input--area {
	z-index: 5;
	margin-right: 1px;

	@include mq($sm) {
		margin-top: 0;
		margin-right: 0;
	}
}

.new-customer-form__input--area,
.new-customer-form__input--list {
	.error-message {
		bottom: 10px;

		@include mq($lg) {
			bottom: 2px;
		}
	}
}

/*--------------------------------------------------------------
## new-customer__breadcrumbs
--------------------------------------------------------------*/
.new-customer__breadcrumbs {
	display: flex;
	align-items: center;
    padding: 42px 30px 32px;
    position: relative;
    margin-bottom: 35px;
	overflow: hidden;

	@include mq($md) {
		flex-direction: column;
		padding: 20px 0;
	}

	&::after {
		content: '';
		width: 1000%;
		height: 1px;
		position: absolute;
		bottom: 0;
		right: 0;
		background-color: $grey-light;

		@include mq($xl) {
			left: 50%;
			transform: translateX(-50%);
			right: auto;
		}
	}

	@include mq($md) {
		margin-bottom: 20px;
	}
}

.section-title--new-customer {
	display: block;
}

.new-customer__breadcrumbs-link {
	color: $fiord;
	transition: $dur $ease;

	@include hover {
		.new-customer__breadcrumbs-icon {
			color: $dodger-blue;
		}
	}
}

.new-customer__breadcrumbs-icon {
	display: flex;
	margin-right: 3px;
	font-size: 29px;
	color: $fiord;

	@include mq($lg) {
		font-size: 25px;
		margin-right: 0;
	}

	@include mq($md) {
		font-size: 20px;
	}
}

.new-customer-form__buttons {
	display: flex;
    justify-content: flex-start;
    align-items: center;
}

.property-form__input-btn-new-agent {
	flex: 0 0 25%;
	max-width: 25%;
	display: flex;
	margin-bottom: -18px !important;
	z-index: 0;
    justify-content: flex-end;

	.btn {
		width: 130px;
	}

	@include mq(1700px) {
		flex: 0 0 35%;
		max-width: 35%;
	}

	@include mq($lg) {
		flex: 0 0 100%;
		justify-content: center;
		max-width: 100%;
		margin-bottom: 20px !important;
		align-self: center;
		width: 130px;
		margin-right: 15px;
	}
}

.popup__new-agent {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 999999;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba($slate-gray, .5);
}

.popup__close {
    position: absolute;
    right: 15px;
    top: 15px;
    color: $fiord;
    font-size: 20px;
    cursor: pointer;
}

.property-form-agents__icon {
	margin-right: 5px;
}

.property-form__input--new-agent {
	.error-message {
		bottom: -21px;
		@include mq($sm) {
			bottom: 0;
		}
	}

	.error-message-holder {
		@include mq($lg) {
			margin-bottom: 25px;
		}
	}
}

.error-message {
	bottom: 12px;
	position: absolute;
	display: inline-block;
	transform: none;

	@include mq($lg) {
		bottom: 0;
	}
}

.range-error {
	bottom: -17px;
}

.loader-dash {
	position: fixed;
}

.error-messages__list {
	margin: -15px auto 20px;

	@include mq($md) {
		margin: 0 auto 20px;
	}
}

.new-customer-form__yearly-price-label {
	display: block;
	font-size: 14px;
	font-family: $font-main;
	line-height: 1.2;
	color: $slate-gray;
	pointer-events: none;
	line-height: 20px;
}

.new-customer-form__yearly-price {
	display: flex;
	align-items: center;
}

.new-customer-form__yearly-price-results {
	display: block;
	box-shadow: none;
	padding: 16px;
	line-height: 1.2;
	font-size: 14px;
	font-family: $font-main;
	color: $fiord;
	transition: $dur $ease;

	@include mq($sm) {
		font-size: 16px;
	}
}

.assign-to-sa-error {
	font-size: 13px;
	color: $fiord;
	line-height: 1.3;
	font-weight: 400;
	letter-spacing: .7px;
	width: 100%;
	text-align: left;
	z-index: 1;
	transition: $dur $ease;
	display: block;
	margin-bottom: 20px;

	@include mq(1280px) {
		font-size: 12px;
	}
}
.assign-to-sa-error-name {
	font-weight: bold;
}
</style>
